<template>
  <router-link
    class="card bg-light mb-3"
    :class="{'opacity-50': !isActive, 'disabled-link': !isActive}"
    :to="routerLinkParams"
  >
    <div class="card-header">
      <h6
        class="p-0 m-0 text-title"
        :title="research.title"
      >
        {{ research.title }}
      </h6>
    </div>
    <div
      class="commercial-img w-100"
      :style="{'background-image': backgroundImage}"
    >
      <div class="commercial-img-inner p-2 d-flex flex-column justify-content-between">
        <div class="d-flex justify-content-end">
          <div
            class="badge badge-pill badge-success mr-2"
            v-if="research.commercial.average_rating"
            v-title="$t('word.average')"
          >
            <i class="fa fa-star-half-alt"></i>
            {{ research.commercial.average_rating.toFixed(2) }}
          </div>
        </div>
        <div class="w-100 d-flex justify-content-between">
          <div>
            <v-badge
              v-if="research.commercial.published_at"
              :title="$t('word.publication_date')"
              icon="calendar"
              :text="stringToPrettyMonthDate(research.commercial.published_at)"
            />
          </div>
          <div class="d-flex">
            <v-research-status-badge
              :status="research.status"
            />
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex';
import Badge from '@/common/components/Badge.vue';
import { stringToPrettyMonthDate } from '@/common/utils/formatting';
import ResearchStatusBadge from '@/common/components/research/ResearchStatusBadge.vue';
import { CLICKABLE_STATUSES } from '@/organisation/services/researches';

export default {
  name: 'OrganisationCommercialResearchCard',
  components: {
    'v-badge': Badge,
    'v-research-status-badge': ResearchStatusBadge,
  },
  props: {
    research: {
      required: true,
      type: Object,
    },
  },
  methods: {
    stringToPrettyMonthDate,
  },
  computed: {
    ...mapGetters(['org']),
    routerLinkParams() {
      if (this.isActive) {
        if (this.research.status === 'draft') {
          return { name: 'organisation-research-edit', params: { uuid: this.research.uuid } };
        }
        return { name: 'organisation-research-dashboard', params: { uuid: this.research.uuid } };
      }
      return {};
    },
    isActive() {
      return CLICKABLE_STATUSES.includes(this.research.status);
    },
    backgroundImage() {
      if (this.research.commercial.image_file) {
        return `url('${this.research.commercial.image_file}')`;
      }

      if (this.research.commercial.commercial_type === 'tv') {
        return `url('${this.research.commercial.youtube_image_url}')`;
      }
      if (this.research.commercial.commercial_type === 'radio') {
        // eslint-disable-next-line global-require
        return `url('${require('@/common/assets/img/radio.jpg')}')`;
      }
      return '';
    },
  },
};
</script>

<style scoped>
.text-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: black;
}

.commercial-img {
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 28%;
  box-sizing: border-box;
  position: relative;
}

.commercial-img-inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.disabled-link {
  cursor: default !important;
}
</style>
